
const Home = {
    text: 'Home',
    link: '/home',
    icon: 'icon-home'
};

const PlatformReport = {
    text: 'Platform Report',
    link: '/subscriber-platform-report',
    icon: 'icon-graph'
};

// const ManageUsers = {
//     link: '/manageusers',
//     icon: 'icon-user'
// };

const ManageSubscribers = {
    text: 'Manage Subscribers',
    link: '/subscribers',
    icon: 'icon-user'
};

const PredictScreen = {
    text: 'PredictScreen Criteria',
    link: '/admin-settings/screening',
    icon: 'icon-user'
};
// const ManageRolesAndPermissions = {
//     link: '/manageRolesAndPermissions',
//     icon: 'icon-user'
// };

const Dashboard = {
    text: 'Dashboard',
    link: '/dashboard',
    icon: 'icon-speedometer',
    submenu: [
        {
            text: 'Dashbord v1',
            link: '/dashboard/v1'
        },
        {
            text: 'Dashbord v2',
            link: '/dashboard/v2'
        },
        {
            text: 'Dashbord v3',
            link: '/dashboard/v3'
        }
    ]
};

const Users = {
    text: 'Users',
    link: '/subscriber_users',
    icon: 'icon-user',
    submenu: [
        {
            text: 'Manage Users',
            link: '/subscriber_users/managesubscriberuser'
        },
        {
            text: 'Manage Roles & Permissions',
            link: '/subscriber_users/manageRolesAndPermissions'
        }
    ]
};

const Properties = {
    text: 'Properties',
    link: '/manageProperties',
    icon: 'icon-grid'
};

const Settings = {
    text: 'Settings',
    link: '/subscriber-settings',
    icon: 'icon-settings',
    submenu: [
        {
            text: 'Email Settings',
            link: '/subscriber-settings/email-settings'
        },
        {
            text: 'Tenant Feedback Setting',
            link: '/tenant-feedback-data'
        },

    ]
};

const Reports = {
    text: 'Order Reports',
    link: '/subscriber-reports/report-list',
    icon: 'far fa-file-alt'

};

// added below to subscriber menu
const managePayment = {
    text: 'Manage Payment',
    link: '/manage-payments',
    icon: 'icon-wallet',
    submenu: [
        {
            text: 'Manage Wallet',
            link: '/subscriber-manage-payment'
        },
        {
            text: 'Manage Invoice',
            link: '/subscriber-manage-invoice'
        }

    ]
};

const tanentData = {
    text: 'Share Feedback',
    link: '/tenant-feedback-data',
    icon: 'icon-wallet'
};
const subscriberTenantManagement = {
    text: 'Tenant Management',
    link: '/tenant-management',
    icon: 'icon-settings'
};

const onlineApplication = {
    text: 'View Application',
    link: '/online-application',
    icon: 'icon-settings'
};

const headingMain = {
    text: 'Main Navigation',
    heading: true
};
const Managementreport = {
    text: 'Management Report',
    link: '/subscriber-reports',
    icon: 'far fa-file-alt',
    submenu: [
        {
            text: 'Analytics Report',
            link: '/subscriber-reports/analytics-report'
        },
        {
            text: 'Applicant report',
            link: '/subscriber-reports/applicant-report'
        }

    ]
};

export const subscribermenu = [
    headingMain,
    Home,
    PlatformReport,
    // Dashboard,
    Users,
    Properties,
    PredictScreen,
    Settings,
    Reports,
    Managementreport,
    managePayment,
    // tanentData,
    subscriberTenantManagement,
     onlineApplication
    // Widgets,
    // ManageSubscribers,
    // headingComponents,
    // Elements,
    // Forms,
    // Charts,
    // Tables,
    // Maps,
    // headingMore,
    // Pages,
    // Blog,
    // Ecommerce,
    // Extras
];
